import { NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TuiAvatar } from '@taiga-ui/kit';
import { TuiBlockStatus } from '@taiga-ui/layout';

/** Componente de estado vazio: exibido quando uma listagem não possui itens. */
@Component({
  selector: 'app-empty',
  standalone: true,
  imports: [TuiAvatar, TuiBlockStatus, NgStyle],
  templateUrl: './empty.component.html',
  styleUrl: './empty.component.scss',
})
export class EmptyComponent {
  @Input() title = '';
  @Input() description = '';
  @Input() icon: string | undefined = undefined;
  @Input() isMobile = false;
}
